import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {KiErgebnis, KiErgebnisService} from '../../../service/ki-ergebnis.service';
import {GrafikUmfang} from '../../../model/event-bus.model';

/**
 * Die grüne Box mit einer KI-Antwort: dass die Anfrage durchging, und der Text.
 *
 * Sie steht zweimal: einmal unter der Leiste oben für den Knopf des Reiters, und einmal
 * über jeder Karten-Zeile für deren eigenen Knopf. Welche Antwort sie zeigt, entscheidet
 * allein der {@link GrafikUmfang}, den sie bekommt.
 *
 * Nötig ist sie, weil der erzeugte Text in einen **anderen** Reiter geschrieben wird
 * (Langwetter): an der Stelle des Knopfes wäre von einem geglückten Durchlauf sonst
 * nichts zu sehen. Eine Erfolgs-Hinweisleiste (Snackbar) tut es nicht – sie wäre nach
 * sechs Sekunden weg, bevor der Text gelesen ist.
 */
@Component({
  selector: 'app-ki-ergebnis-box',
  templateUrl: './ki-ergebnis-box.component.html',
  styleUrls: ['./ki-ergebnis-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, DatePipe]
})
export class KiErgebnisBoxComponent implements OnInit {

  /**
   * Der Umfang, dessen Antwort gezeigt wird – der Reiter oder eine seiner Zeilen.
   *
   * ⚠️ Muss ein **stabiles** Objekt sein: bei jedem Aufruf neu gebaut hätte es jedes Mal
   * eine neue Identität, und die Verifizierungs-Prüfung im Entwicklungsmodus meldete das
   * als Änderung nach der Prüfung (**NG0100**). Die Elemente-Komponente merkt sich ihre
   * Umfänge deshalb.
   */
  @Input() umfang: GrafikUmfang | null = null;

  constructor(private kiErgebnisService: KiErgebnisService) {
  }

  /**
   * Meldet eine fehlende `umfang`-Bindung.
   *
   * Ohne sie sucht die Box eine Antwort ohne Schlüssel und bleibt **für immer leer** –
   * ein Fehler, den man nicht sieht, sondern nur vermisst (genau die Klasse von Fehlern,
   * die auf dieser Seite schon zweimal zugeschlagen hat). Eine Warnung macht ihn sichtbar.
   */
  ngOnInit(): void {
    if (!this.umfang) {
      console.warn('KI-Ergebnis-Box ohne [umfang]: sie kann nie eine Antwort zeigen.');
    }
  }

  /**
   * Die anzuzeigende Antwort, oder null wenn für diesen Umfang keine vorliegt.
   *
   * Der Zugriff liest ein Signal, also merkt Angular sich diese Ansicht als Verbraucher
   * und prüft sie neu, sobald die Antwort eintrifft – auch wenn sie aus einem
   * HTTP-Callback kommt.
   */
  get ergebnis(): KiErgebnis | null {
    return this.kiErgebnisService.ergebnisFuer(this.umfang);
  }

  /** Blendet diese Box wieder aus; die der anderen Umfänge bleiben stehen. */
  schliessen(): void {
    this.kiErgebnisService.leeren(this.umfang);
  }
}
